import { render, staticRenderFns } from "./SpecialSubject.vue?vue&type=template&id=b7d30b90&scoped=true&"
import script from "./SpecialSubject.vue?vue&type=script&lang=ts&"
export * from "./SpecialSubject.vue?vue&type=script&lang=ts&"
import style0 from "./SpecialSubject.vue?vue&type=style&index=0&id=b7d30b90&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7d30b90",
  null
  
)

export default component.exports